import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout.vue'

Vue.use(Router)

//  解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// 解决编程式路由往同一地址跳转时会报错的情况
// const originalPush = Router.prototype.push
// const originalReplace = Router.prototype.replace
// // push
// Router.prototype.push = function push (location, onResolve, onReject) {
//   if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
//   return originalPush.call(this, location).catch(err => err)
// }
// // replace
// Router.prototype.replace = function push (location, onResolve, onReject) {
//   if (onResolve || onReject) { return originalReplace.call(this, location, onResolve, onReject) }
//   return originalReplace.call(this, location).catch(err => err)
// }

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: () => import('@/views/login/index')
    },
    {
      path: '*',
      component: () => import('@/components/404')
    },
    {
      path: '/errorNopermission',
      component: () => import('@/components/errorNopermission')
    },
    {
      path: '/homePage',
      name: 'homePage',
      component: Layout,
      children: [
        {
          path: '/homePage',
          name: '主页',
          component: () => import('@/views/homePage')
        }
      ]
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: Layout,
      children: [
        {
          path: '/homePage/personalCenter',
          name: '个人中心',
          component: () => import('@/views/homePage/personalCenter')
        }
      ]
    },
    {
      path: '/notification',
      name: 'notification',
      component: Layout,
      children: [
        {
          path: '/homePage/notification',
          name: '消息通知',
          component: () => import('@/views/homePage/notification')
        }
      ]
    },
    // {
    //   path: '/informationManagement',
    //   name: 'informationManagement',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'msgSendManagement',
    //       name:'信息发布',
    //       component: ()=> import('@/views/informationManagement/msgSendManagement'),
    //       children: [
    //         {
    //           path: 'publishedManagement',
    //           name: '已发布消息',
    //           component: () => import('@/views/informationManagement/msgSendManagement/publishedManagement')
    //         },
    //         {
    //           path: 'draftsManagement',
    //           name: '草稿箱',
    //           component: () => import('@/views/informationManagement/msgSendManagement/draftsManagement')
    //         }
    //       ]
    //     },
    //     {
    //       path: 'basicSetting',
    //       name:'基础设置',
    //       component: () => import('@/views/informationManagement/basicSetting'),
    //       children: [
    //         {
    //           path: 'classificationSetting',
    //           name:'分类设置',
    //           component: () => import('@/views/informationManagement/basicSetting/classificationSetting')
    //         }
    //       ]
    //     }
    //   ]
    // },
    {
      path: '/system',
      name: 'system',
      // redirect: '/system/permissionSetting/roleManagement',
      component: Layout,
      children: [
        {
          path: 'permissionSetting',
          name: '权限设置',
          component: () => import('@/views/system/permissionSetting'),
          children: [
            {
              path: 'roleManagement',
              name: '角色管理',
              component: () => import('@/views/system/permissionSetting/roleManagement')
            },
            {
              path: 'administratorManagement',
              name: '管理员管理',
              component: () => import('@/views/system/permissionSetting/administratorManagement')
            }
          ]
        },
        {
          path: 'ApppermissionSetting',
          name: 'APP权限设置',
          component: () => import('@/views/system/ApppermissionSetting'),
          children: [
            {
              path: 'roleManagement',
              name: 'App角色管理',
              component: () => import('@/views/system/ApppermissionSetting/roleManagement')
            },
            {
              path: 'administratorManagement',
              name: 'App管理员管理',
              component: () => import('@/views/system/ApppermissionSetting/administratorManagement')
            }
          ]
        },
        {
          path: 'empPermissionSetting',
          name: '员工端权限设置',
          component: () => import('@/views/system/empPermissionSetting'),
          children: [
            {
              path: 'roleManagement',
              name: '角色管理',
              component: () => import('@/views/system/empPermissionSetting/roleManagement')
            },
            {
              path: 'administratorManagement',
              name: '管理员管理',
              component: () => import('@/views/system/empPermissionSetting/administratorManagement')
            }
          ]
        },
        {
          path: 'msgSendManagement',
          name: '消息发送',
          component: () => import('@/views/system/msgSendManagement'),
          children: [
            {
              path: 'publishedManagement',
              name: '已发布消息',
              component: () => import('@/views/system/msgSendManagement/publishedManagement')
            },
            {
              path: 'draftsManagement',
              name: '草稿箱',
              component: () => import('@/views/system/msgSendManagement/draftsManagement')
            },
            {
              path: 'newsPushBuy',
              name: '购买记录',
              component: () => import('@/views/system/msgSendManagement/newsPushBuy')
            }
          ]
        },
        {
          path: 'ruleManager',
          name: '审批管理',
          component: () => import('@/views/system/ruleManager'),
          children: [
            {
              path: 'modelSetting',
              name: '审批模板设置',
              component: () => import('@/views/system/ruleManager/modelSetting')
            },
            {
              path: 'ruleSetting',
              name: '审批/退费规则设置',
              component: () => import('@/views/system/ruleManager/ruleSetting')
            },
            {
              path: 'applyApprove',
              name: '申请审批',
              component: () => import('@/views/system/ruleManager/applyApprove')
            },
            {
              path: 'approveApply',
              name: '审批申请',
              component: () => import('@/views/system/ruleManager/approveApply')
            },
            {
              path: 'approveApplyRecord',
              name: '申请审批记录',
              component: () => import('@/views/system/ruleManager/approveApplyRecord')
            }
          ]
        },
        {
          path: 'feedback',
          name: '意见反馈',
          component: () => import('@/views/system/feedback')
        },
        {
          path: 'resource',
          name: '资源共享',
          component: () => import('@/views/system/resource'),
          children: [
            {
              path: 'resourceAdmin',
              name: '资源管理',
              component: () => import('@/views/system/resource/resourceAdmin')
            },
            {
              path: 'resourceClassifySet',
              name: '资源分类设置',
              component: () => import('@/views/system/resource/resourceClassifySet')
            }
          ]
        },
        {
          path: 'pointManage',
          name: '积分管理',
          component: () => import('@/views/system/pointManage'),
          children: [
            {
              path: 'pointManageSetting',
              name: '积分模板管理',
              component: () => import('@/views/system/pointManage/pointManageSetting')
            },
            {
              path: 'pointUserManage',
              name: '用户积分管理',
              component: () => import('@/views/system/pointManage/pointUserManage')
            }
          ]
        }
        // {
        //   path: 'holidaySetting',
        //   name: '节假日设置',
        //   component: () => import('@/views/system/holidaySetting')
        // }
      ]
    },
    {
      path: '/personnel',
      name: 'personnel',
      component: Layout,
      // redirect: '/personnel/staffManagement/staffBasicManagement',
      children: [
        {
          path: 'staffManagement',
          name: '员工管理',
          component: () => import('@/views/personnel/staffManagement'),
          children: [
            {
              path: 'staffBasicManagement',
              name: '员工基础管理',
              component: () => import('@/views/personnel/staffManagement/staffBasicManagement')
            },
            {
              path: 'staffFileConfiguration',
              name: '员工档案配置',
              component: () => import('@/views/personnel/staffManagement/staffFileConfiguration')
            }
          ]
        },
        {
          path: 'employeeRelations',
          name: '员工关系',
          // redirect: '/finance/gardenChargeStatistics',
          component: () => import('@/views/personnel/employeeRelations'),
          // component: 'finance',
          children: [
            {
              path: 'entryManagement',
              name: '入职管理',
              component: () => import('@/views/personnel/employeeRelations/entryManagement')
            },
            {
              path: 'positiveManagement',
              name: '转正管理',
              component: () => import('@/views/personnel/employeeRelations/positiveManagement')
            },
            {
              path: 'resignationManagement',
              name: '离职管理',
              component: () => import('@/views/personnel/employeeRelations/resignationManagement')
            },
            {
              path: 'changeRcord',
              name: '异动记录',
              component: () => import('@/views/personnel/employeeRelations/changeRcord')
            },
            {
              path: 'applicationRecords',
              name: '员工关系申请记录',
              component: () => import('@/views/personnel/employeeRelations/applicationRecords')
            }
          ]
        },
        {
          path: 'attendanceManagement',
          name: '考勤管理',
          component: () => import('@/views/personnel/attendanceManagement'),
          // component: 'finance',
          children: [
            {
              path: 'attendanceStatistics',
              name: '员工考勤统计',
              component: () => import('@/views/personnel/attendanceManagement/attendanceStatistics')
            },
            {
              path: 'scheduling',
              name: '排班',
              component: () => import('@/views/personnel/attendanceManagement/scheduling')
            },
            {
              path: 'applicationRecords',
              name: '申请记录',
              component: () => import('@/views/personnel/attendanceManagement/applicationRecords')
            },
            {
              path: 'kindergartenAttendance',
              name: '申请记录',
              component: () => import('@/views/personnel/attendanceManagement/kindergartenAttendance')
            },
            {
              path: 'holidayManagement',
              name: '假期余额管理',
              component: () => import('@/views/personnel/attendanceManagement/holidayManagement')
            }
          ]
        },
        {
          path: 'basicSetting',
          name: '基础设置',
          component: () => import('@/views/personnel/basicSetting'),
          children: [
            {
              path: 'positionSetting',
              name: '职位设置',
              component: () => import('@/views/personnel/basicSetting/positionSetting')
            },
            {
              path: 'shiftSetting',
              name: '班次设置',
              component: () => import('@/views/personnel/basicSetting/shiftSetting')
            },
            {
              path: 'organization',
              name: '组织架构',
              component: () => import('@/views/system/organization')
            },
            {
              path: 'clockSetting',
              name: '打卡设置',
              component: () => import('@/views/personnel/basicSetting/clockSetting')
            }
          ]
        }
      ]
    },
    {
      path: '/finance',
      name: 'finance',
      component: Layout,
      // redirect: '/finance/chargeManagement/feeManagement',
      children: [
        {
          path: 'financeDynamic',
          name: '财务动态',
          component: () => import('@/views/finance/financeDynamic')
        },
        {
          path: 'cashFlowManagement',
          name: '现金流管理',
          component: () => import('@/views/finance/cashFlowManagement'),
          children: [
            {
              path: 'capitalFlowStatement',
              name: '资金流量表',
              component: () => import('@/views/finance/cashFlowManagement/capitalFlowStatement')
            },
            {
              path: 'transactionManagement',
              name: '往来业务管理',
              component: () => import('@/views/finance/cashFlowManagement/transactionManagement')
            }
          ]
        },
        {
          path: 'chargeManagement',
          name: '收费管理',
          component: () => import('@/views/finance/chargeManagement'),
          children: [
            {
              path: 'feeManagement',
              name: '账单管理',
              component: () => import('@/views/finance/chargeManagement/feeManagement')
            },
            {
              path: 'feeManagementCheck',
              name: '账单管理(新)',
              component: () => import('@/views/finance/chargeManagement/feeManagementCheck')
            },
            {
              path: 'chargeRecord',
              name: '收费记录',
              component: () => import('@/views/finance/chargeManagement/chargeRecord')
            },
            {
              path: 'refundRecord',
              name: '退费记录',
              component: () => import('@/views/finance/chargeManagement/refundRecord')
            },
            {
              path: 'statistics',
              name: '收费统计',
              component: () => import('@/views/finance/chargeManagement/statistics')
            },
            {
              path: 'otherIncome',
              name: '其他收入',
              component: () => import('@/views/finance/chargeManagement/otherIncome')
            }
          ]
        },
        {
          path: 'chargeSummary',
          name: '收费汇总',
          component: () => import('@/views/finance/chargeSummary'),
          children: [
            {
              path: 'chargeStatistics',
              name: '收退费统计',
              component: () => import('@/views/finance/chargeSummary/chargeStatistics')
            },
            {
              path: 'noPayStatistics',
              name: '未缴费统计',
              component: () => import('@/views/finance/chargeSummary/noPayStatistics')
            },
            {
              path: 'accountStatistics',
              name: '收款账号统计',
              component: () => import('@/views/finance/chargeSummary/accountStatistics')
            },
            {
              path: 'ledgerPower',
              name: '台账（权责）',
              component: () => import('@/views/finance/chargeSummary/ledgerPower')
            },
            {
              path: 'ledgerPowerCheck',
              name: '台账（权责）新',
              component: () => import('@/views/finance/chargeSummary/ledgerPowerCheck')
            },
            {
              path: 'ledgerFlow',
              name: '台账（流量）',
              component: () => import('@/views/finance/chargeSummary/ledgerFlow')
            }
          ]
        },
        {
          path: 'applicationRecords',
          name: '财务申请记录',
          component: () => import('@/views/finance/applicationRecords'),
          children: [
            {
              path: 'refundApply',
              name: '退费申请',
              component: () => import('@/views/finance/applicationRecords/refundApply')
            },
            {
              path: 'reimbursementApply',
              name: '报销申请',
              component: () => import('@/views/finance/applicationRecords/reimbursementApply')
            },
            {
              path: 'transferFeeApply',
              name: '移费申请',
              component: () => import('@/views/finance/applicationRecords/transferFeeApply')
            },
            {
              path: 'contactsApply',
              name: '往来申请',
              component: () => import('@/views/finance/applicationRecords/contactsApply')
            },
            {
              path: 'internalTransferApply',
              name: '内部转账申请',
              component: () => import('@/views/finance/applicationRecords/internalTransferApply')
            }
          ]
        },
        {
          path: 'financialApproval',
          name: '财务审批',
          component: () => import('@/views/finance/financialApproval'),
          children: [
            {
              path: 'reimbursementApproval',
              name: '报销审批',
              component: () => import('@/views/finance/financialApproval/reimbursementApproval')
            },
            {
              path: 'refundApproval',
              name: '退费审批',
              component: () => import('@/views/finance/financialApproval/refundApproval')
            },
            {
              path: 'transferFeeApproval',
              name: '移费审批',
              component: () => import('@/views/finance/financialApproval/transferFeeApproval')
            },
            {
              path: 'contactsApproval',
              name: '往来审批',
              component: () => import('@/views/finance/financialApproval/contactsApproval')
            },
            {
              path: 'internalTransferApproval',
              name: '内部转账审批',
              component: () => import('@/views/finance/financialApproval/internalTransferApproval')
            }
          ]
        },
        {
          path: 'budgetManagement',
          name: '预算表管理',
          component: () => import('@/views/finance/budgetManagement'),
          children: [
            {
              path: 'annualBudget',
              name: '年度预算',
              component: () => import('@/views/finance/budgetManagement/annualBudget')
            },
            {
              path: 'budgetPerformance',
              name: '预算执行情况',
              component: () => import('@/views/finance/budgetManagement/budgetPerformance')
            },
            {
              path: 'extraBudget',
              name: '额外预算',
              component: () => import('@/views/finance/budgetManagement/extraBudget')
            },
            {
              path: 'budgetStatistics',
              name: '预算统计',
              component: () => import('@/views/finance/budgetManagement/budgetStatistics')
            }
          ]
        },
        {
          path: 'basicSettings',
          name: '财务基础设置',
          component: () => import('@/views/finance/basicSettings'),
          children: [
            {
              path: 'chargeItemSetting',
              name: '收退费项金额设置',
              component: () => import('@/views/finance/basicSettings/chargeItemSetting')
            },
            {
              path: 'createClassifySettings',
              name: '收退费分类设置',
              component: () => import('@/views/finance/basicSettings/createClassifySettings')
            },
            {
              path: 'createCostSettings',
              name: '收退费项目设置',
              component: () => import('@/views/finance/basicSettings/createCostSettings')
            },
            {
              path: 'collectionAccount',
              name: '收款账号',
              component: () => import('@/views/system/collectionAccount')
            },
            {
              path: 'accountManagement',
              name: '账号管理',
              component: () => import('@/views/finance/basicSettings/accountManagement')
            },
            {
              path: 'budgetBasicSettings',
              name: '预算基础设置',
              component: () => import('@/views/finance/basicSettings/budgetBasicSettings')
            },
            {
              path: 'budgetExecutionSettings',
              name: '预算执行设置',
              component: () => import('@/views/finance/basicSettings/budgetExecutionSettings')
            },
            {
              path: 'companyAssociation',
              name: '关联公司',
              component: () => import('@/views/finance/basicSettings/companyAssociation')
            }
          ]
        }
      ]
    },
    {
      path: '/garden',
      name: 'garden',
      component: Layout,
      // redirect: '/garden/babyManagement/babyInforManagement',
      children: [
        {
          path: 'babyManagement',
          name: '宝宝管理',
          component: () => import('@/views/garden/babyManagement'),
          children: [
            {
              path: 'babyInforManagement',
              name: '宝宝信息管理',
              component: () => import('@/views/garden/babyManagement/babyInforManagement')
            },
            {
              path: 'babyArchivesSetting',
              name: '宝宝档案设置',
              component: () => import('@/views/garden/babyManagement/babyArchivesSetting')
            },
            {
              path: 'babyTransactionRecord',
              name: '宝宝异动记录',
              component: () => import('@/views/garden/babyManagement/babyTransactionRecord')
            }
          ]
        },
        {
          path: 'babyAttendance',
          name: '宝宝出勤',
          component: () => import('@/views/garden/babyAttendance'),
          children: [
            {
              path: 'attendanceStatistics',
              name: '出勤统计',
              component: () => import('@/views/garden/babyAttendance/attendanceStatistics')
            },
            {
              path: 'attendanceDetails',
              name: '出勤详情',
              component: () => import('@/views/garden/babyAttendance/attendanceDetails')
            },
            // {
            //   path: 'signinRecord',
            //   name: '签到记录',
            //   component: () => import('@/views/garden/babyAttendance/signinRecord')
            // },
            {
              path: 'attendanceSetting',
              name: '出勤设置',
              component: () => import('@/views/garden/babyAttendance/attendanceSetting')
            },
            {
              path: 'healthFitnessReport',
              name: '保健月报',
              component: () => import('@/views/garden/babyAttendance/attendanceReport')
            },
            {
              path: 'attendancePost',
              name: '宝宝驿站',
              component: () => import('@/views/garden/babyAttendance/attendancePost')
            }
          ]
        },
        {
          path: 'classManagement',
          name: '班级管理',
          component: () => import('@/views/garden/classManagement')
        },
        {
          path: 'classType',
          name: '班级类型',
          component: () => import('@/views/system/classType')
        },
        {
          path: 'timeSetting',
          name: '时间设置',
          component: () => import('@/views/garden/timeSetting')
        },
        {
          path: 'cameraManage',
          name: '摄像头管理',
          component: () => import('@/views/garden/cameraManage')
        },
        {
          path: 'attendanceEquipmentManagement',
          name: '考勤设备管理',
          component: () => import('@/views/garden/attendanceEquipmentManagement')
        },
        {
          path: 'attendanceEquipmentMaintain',
          name: '考勤设备维护',
          component: () => import('@/views/garden/attendanceEquipmentMaintain')
        },
        {
          path: 'cameraSetting',
          name: '摄像头配置',
          component: () => import('@/views/garden/cameraSetting')
        },
        {
          path: 'classSetting',
          name: '班级配置',
          component: () => import('@/views/garden/classSetting')
        },
        {
          path: 'groupPostSetting',
          name: '集团驿站设置',
          component: () => import('@/views/garden/groupPostSetting')
        },
        {
          path: 'orgPostSetting',
          name: '园所驿站设置',
          component: () => import('@/views/garden/orgPostSetting')
        },
        {
          path: 'calendarSetting',
          name: '行事历设置',
          component: () => import('@/views/garden/calendarSetting')
        },
        {
          path: 'calendarWrite',
          name: '行事历',
          component: () => import('@/views/garden/calendarWrite')
        },
        {
          path: 'baseSetting',
          name: '标签基础设置',
          component: () => import('@/views/garden/baseSetting'),
          children: [
            {
              path: 'labelManage',
              name: '标签管理',
              component: () => import('@/views/garden/baseSetting/labelManage')
            },
            {
              path: 'labelType',
              name: '标签类型',
              component: () => import('@/views/garden/baseSetting/labelType')
            }
          ]
        }
      ]
    },
    {
      path: '/educationManagerment',
      name: 'educationManagerment',
      component: Layout,
      children: [
        {
          path: 'homeland',
          name: '家园沟通',
          component: () => import('@/views/educationManagerment/homeland'),
          children: [
            {
              path: 'homelandCommunication',
              name: '家园沟通信息',
              component: () => import('@/views/educationManagerment/homeland/homelandCommunication')
            },
            {
              path: 'homelandTemplet',
              name: '家园沟通模板',
              component: () => import('@/views/educationManagerment/homeland/homelandTemplet')
            },
            {
              path: 'commouicationSettings',
              name: '沟通项目设置',
              component: () => import('@/views/educationManagerment/homeland/commouicationSettings')
            },
            {
              path: 'classSettings',
              name: '班级沟通设置',
              component: () => import('@/views/educationManagerment/homeland/classSettings')
            },
            {
              path: 'homelandStatis',
              name: '家园沟通统计',
              component: () => import('@/views/educationManagerment/homeland/homelandStatis')
            }
          ]
        },
        {
          path: 'classCircle',
          name: '班级圈',
          component: () => import('@/views/educationManagerment/classCircle'),
          children: [
            {
              path: 'lableSetting',
              name: '班级圈标签设置',
              component: () => import('@/views/educationManagerment/classCircle/lableSetting')
            },
            {
              path: 'classCircleStatistics',
              name: '班级圈统计',
              component: () => import('@/views/educationManagerment/classCircle/classCircleStatistics')
            }
          ]
        },
        {
          path: 'growthFile',
          name: '成长档案',
          component: () => import('@/views/educationManagerment/growthFile'),
          children: [
            {
              path: 'profileTemplateSettings',
              name: '档案模板设置',
              component: () => import('@/views/educationManagerment/growthFile/profileTemplateSettings')
            },
            {
              path: 'profileThemeSettings',
              name: '档案主题设置',
              component: () => import('@/views/educationManagerment/growthFile/profileThemeSettings')
            },
            {
              path: 'profileCostSettings',
              name: '档案费用设置',
              component: () => import('@/views/educationManagerment/growthFile/profileCostSettings')
            },
            {
              path: 'profileManage',
              name: '档案管理',
              component: () => import('@/views/educationManagerment/growthFile/profileManage')
            },
            {
              path: 'growthFileStatis',
              name: '成长册统计',
              component: () => import('@/views/educationManagerment/growthFile/growthFileStatis')
            },
            {
              path: 'growthFileAudit',
              name: '成长册审核',
              component: () => import('@/views/educationManagerment/growthFile/growthFileAudit')
            }
          ]
        },
        {
          path: 'growthAssessment',
          name: '成长评估',
          component: () => import('@/views/educationManagerment/growthAssessment'),
          children: [
            {
              path: 'assessmentManager',
              name: '评估内容管理',
              component: () => import('@/views/educationManagerment/growthAssessment/assessmentManager')
            },
            {
              path: 'assessmentModelManager',
              name: '评估模板管理',
              component: () => import('@/views/educationManagerment/growthAssessment/assessmentModelManager')
            },
            {
              path: 'assessmentManagerQuery',
              name: '评估管理信息',
              component: () => import('@/views/educationManagerment/growthAssessment/assessmentManagerQuery')
            },
            {
              path: 'assessmentManagerStatis',
              name: '发展评估统计',
              component: () => import('@/views/educationManagerment/growthAssessment/assessmentManagerStatis')
            }
          ]
        },
        {
          path: 'babyBuildAssess',
          name: '体格评估',
          component: () => import('@/views/educationManagerment/babyBuildAssess'),
          children: [
            {
              path: 'growAssess',
              name: '生长发育评估',
              component: () => import('@/views/educationManagerment/babyBuildAssess/growAssess')
            }
          ]
        },
        {
          path: 'gardenRecipe',
          name: '园所食谱',
          component: () => import('@/views/educationManagerment/gardenRecipe'),
          children: [
            {
              path: 'recipetypemanage',
              name: '菜品管理',
              component: () => import('@/views/educationManagerment/gardenRecipe/recipetypemanage')
            },
            {
              path: 'weeklyRecipe',
              name: '每周食谱',
              component: () => import('@/views/educationManagerment/gardenRecipe/weeklyRecipe')
            },
            {
              path: 'recipetypeset',
              name: '园所餐别设置',
              component: () => import('@/views/educationManagerment/gardenRecipe/recipetypeset')
            }
          ]
        },
        {
          path: 'settings',
          name: '保教基础设置',
          component: () => import('@/views/educationManagerment/settings'),
          children: [
            {
              path: 'lableSettings',
              name: '语句库标签管理',
              component: () => import('@/views/educationManagerment/settings/lableSettings')
            },
            {
              path: 'contentSettings',
              name: '语句库内容管理',
              component: () => import('@/views/educationManagerment/settings/contentSettings')
            },
            {
              path: 'evaluateContent',
              name: '评估内容设置',
              component: () => import('@/views/educationManagerment/settings/evaluateContent')
            },
            {
              path: 'foodManage',
              name: '食谱食材管理',
              component: () => import('@/views/educationManagerment/settings/foodManage')
            },
            {
              path: 'dishesvariety',
              name: '食谱菜品管理',
              component: () => import('@/views/educationManagerment/settings/dishesvariety')
            },
            {
              path: 'nutrientContent',
              name: '食材营养成分管理',
              component: () => import('@/views/educationManagerment/settings/nutrientContent')
            },
            {
              path: 'nutrient',
              name: '食材营养管理',
              component: () => import('@/views/educationManagerment/settings/nutrient')
            },
            {
              path: 'taskClassify',
              name: '任务分类管理',
              component: () => import('@/views/educationManagerment/settings/taskClassify')
            },

            {
              path: 'growthMilestoneManager',
              name: '成长里程碑管理',
              component: () => import('@/views/educationManagerment/settings/growthMilestoneManager')
            },
            {
              path: 'growthObservedContent',
              name: '成长观察内容设置',
              component: () => import('@/views/educationManagerment/settings/growthObservedContent')
            },
            {
              path: 'dayProcess',
              name: '一日流程模板管理',
              component: () => import('@/views/educationManagerment/settings/dayProcess')
            },
            {
              path: 'teachingPlanSetting',
              name: '教学计划设置',
              component: () => import('@/views/educationManagerment/settings/teachingPlanSetting')
            },
            {
              path: 'weekCourseItemSetting',
              name: '每周课程项目设置',
              component: () => import('@/views/educationManagerment/settings/weekCourseItemSetting')
            },
            {
              path: 'weekCourseModelSetting',
              name: '每周课程模板',
              component: () => import('@/views/educationManagerment/settings/weekCourseModelSetting')
            },
            {
              path: 'courseActivityLableSetting',
              name: '课程活动项目设置',
              component: () => import('@/views/educationManagerment/settings/courseActivityLableSetting')
            },
            {
              path: 'courseActivityResource',
              name: '课程活动资源',
              component: () => import('@/views/educationManagerment/settings/courseActivityResource')
            },
            {
              path: 'parentsAppSetting',
              name: '家长APP设置',
              component: () => import('@/views/educationManagerment/settings/parentsAppSetting')
            }
          ]
        },
        {
          path: 'task',
          name: '松果任务',
          component: () => import('@/views/educationManagerment/task'),
          children: [
            {
              path: 'taskTemplate',
              name: '任务模板管理',
              component: () => import('@/views/educationManagerment/task/taskTemplate')
            },
            {
              path: 'teacherTask',
              name: '园丁任务',
              component: () => import('@/views/educationManagerment/task/teacherTask')
            },
            {
              path: 'patriarchTask',
              name: '亲子任务',
              component: () => import('@/views/educationManagerment/task/patriarchTask')
            },
            {
              path: 'patriarchNoticeTask',
              name: '亲子通知',
              component: () => import('@/views/educationManagerment/task/patriarchNoticeTask')
            }
          ]
        },
        {
          path: 'babyMial',
          name: '园长邮箱',
          component: () => import('@/views/educationManagerment/babyMial')
        },
        {
          path: 'babyPhotoAlbum',
          name: '宝宝相册',
          component: () => import('@/views/educationManagerment/babyPhotoAlbum')
        },
        {
          path: 'babyClassCircle',
          name: '班级圈',
          component: () => import('@/views/educationManagerment/babyClassCirclePC')
        },
        {
          path: 'themeResource',
          name: '主题资源库',
          component: () => import('@/views/educationManagerment/themeResource')
        },
        {
          path: 'mutilaugntassessment',
          name: '多元主体评估',
          component: () => import('@/views/educationManagerment/mutilaugntassessment'),
          children: [
            {
              path: 'growthObservedContentManager',
              name: '成长观察内容管理',
              component: () => import('@/views/educationManagerment/mutilaugntassessment/growthObservedContentManager')
            },
            {
              path: 'growthObservedModelManager',
              name: '成长观察模板管理',
              component: () => import('@/views/educationManagerment/mutilaugntassessment/growthObservedModelManager')
            },
            {
              path: 'growthObservedManager',
              name: '成长观察管理',
              component: () => import('@/views/educationManagerment/mutilaugntassessment/growthObservedManager')
            },
            {
              path: 'parentObservedContentManager',
              name: '家长观察内容管理',
              component: () => import('@/views/educationManagerment/mutilaugntassessment/parentObservedContentManager')
            },
            {
              path: 'parentObservedModelManager',
              name: '家长观察模板管理',
              component: () => import('@/views/educationManagerment/mutilaugntassessment/parentObservedModelManager')
            },
            {
              path: 'parentObservedManager',
              name: '家长观察管理',
              component: () => import('@/views/educationManagerment/mutilaugntassessment/parentObservedManager')
            },
            {
              path: 'growthObserved',
              name: '成长观察管理',
              component: () => import('@/views/educationManagerment/mutilaugntassessment/growthObserved')
            },
            {
              path: 'growthObservedStatis',
              name: '成长观察管理',
              component: () => import('@/views/educationManagerment/mutilaugntassessment/growthObservedStatis')
            }
          ]
        },
        {
          path: 'graduationGift',
          name: '毕业礼物',
          component: () => import('@/views/educationManagerment/graduationGift'),
          children: [
            {
              path: 'graduationGiftList',
              name: '毕业礼物列表',
              component: () => import('@/views/educationManagerment/graduationGift/graduationGiftList')
            },
            {
              path: 'graduationGiftSetting',
              name: '毕业礼物设置',
              component: () => import('@/views/educationManagerment/graduationGift/graduationGiftSetting')
            }
          ]
        },
        {
          path: 'songguoReport',
          name: '松果报告',
          component: () => import('@/views/educationManagerment/songguoReport'),
          children: [
            {
              path: 'reportTemplate',
              name: '松果报告模板',
              component: () => import('@/views/educationManagerment/songguoReport/reportTemplate')
            }
          ]
        }
      ]
    },
    {
      path: '/enrollment',
      name: 'enrollment',
      component: Layout,
      children: [
        {
          path: 'potentialCustomers',
          name: '招生管理',
          component: () => import('@/views/enrollment/potentialCustomers'),
          children: [
            {
              path: 'customerInformation',
              name: '客户信息管理',
              component: () => import('@/views/enrollment/potentialCustomers/customerInformation')
            },
            {
              path: 'enrollmentTrends',
              name: '招生动态详情',
              component: () => import('@/views/enrollment/potentialCustomers/enrollmentTrends')
            },
            {
              path: 'enrollmentOrcode',
              name: '招生二维码',
              component: () => import('@/views/enrollment/potentialCustomers/enrollmentOrcode')
            },
            {
              path: 'possibleList',
              name: '毛名单',
              component: () => import('@/views/enrollment/potentialCustomers/possibleList')
            }
          ]
        },
        {
          path: 'performanceData',
          name: '业绩数据',
          component: () => import('@/views/enrollment/performanceData'),
          children: [
            {
              path: 'parkPerformance',
              name: '园所业绩',
              component: () => import('@/views/enrollment/performanceData/parkPerformance')
            },
            {
              path: 'employeePerformance',
              name: '员工业绩',
              component: () => import('@/views/enrollment/performanceData/employeePerformance')
            }
          ]
        },
        {
          path: 'conversionRate',
          name: '转化率统计',
          component: () => import('@/views/enrollment/conversionRate'),
          children: [
            {
              path: 'enrollmentFunnel',
              name: '招生漏斗',
              component: () => import('@/views/enrollment/conversionRate/enrollmentFunnel')
            },
            {
              path: 'parkTransformation',
              name: '园所转化',
              component: () => import('@/views/enrollment/conversionRate/parkTransformation')
            },
            {
              path: 'employeeConversion',
              name: '员工转化',
              component: () => import('@/views/enrollment/conversionRate/employeeConversion')
            }
          ]
        },
        {
          path: 'customerAnalysis',
          name: '客户分析',
          component: () => import('@/views/enrollment/customerAnalysis')
        },
        {
          path: 'baseSetting',
          name: '基础设置1',
          component: () => import('@/views/enrollment/baseSetting'),
          children: [
            {
              path: 'customerServiceManagement',
              name: '客服管理',
              component: () => import('@/views/enrollment/baseSetting/customerServiceManagement')
            },
            {
              path: 'admissionGoal',
              name: '招生目标',
              component: () => import('@/views/enrollment/baseSetting/admissionGoal')
            }
          ]
        }
      ]
    },
    {
      path: '/plateformOperation',
      name: 'plateformOperation',
      component: Layout,
      children: [
        {
          path: 'orgOnline',
          name: '园所在线视频',
          component: () => import('@/views/plateformOperation/orgOnline'),
          children: [
            {
              path: 'videoChargeSetting',
              name: '视频收费设置',
              component: () => import('@/views/system/videoCharge/videoChargeSetting')
            },
            {
              path: 'openedParents',
              name: '已开通家长列表',
              component: () => import('@/views/system/videoCharge/openedParents')
            }
          ]
        },
        {
          path: 'babyRegistration',
          name: '宝宝注册',
          component: () => import('@/views/system/babyRegistration'),
          children: [
            {
              path: 'babyRegistrationSetting',
              name: '宝宝注册设置',
              component: () => import('@/views/system/babyRegistration/babyRegistrationSetting')
            },
            {
              path: 'chargeTemplateSetting',
              name: '收费模板设置',
              component: () => import('@/views/system/babyRegistration/chargeTemplateSetting')
            },
            {
              path: 'registraBuyRecord',
              name: '购买记录',
              component: () => import('@/views/system/babyRegistration/registraBuyRecord')
            }
          ]
        },
        {
          path: 'userCoupon',
          name: '优惠券管理',
          component: () => import('@/views/plateformOperation/userCoupon'),
          children: [
            {
              path: 'couponSetting',
              name: '优惠券设置',
              component: () => import('@/views/plateformOperation/userCoupon/couponSetting')
            },
            {
              path: 'couponUse',
              name: '优惠券发放',
              component: () => import('@/views/plateformOperation/userCoupon/couponUse')
            }

          ]
        },
        {
          path: 'parentProCharge',
          name: '家长收费',
          component: () => import('@/views/plateformOperation/parentProCharge'),
          children: [
            {
              path: 'babyProSetting',
              name: '宝宝商品设置',
              component: () => import('@/views/plateformOperation/parentProCharge/babyProSetting')
            },
            {
              path: 'proOrderManage',
              name: '商品订单管理',
              component: () => import('@/views/plateformOperation/parentProCharge/proOrderManage')
            }

          ]
        },
        {
          path: 'heartChat',
          name: '心聊治愈',
          component: () => import('@/views/plateformOperation/heartChat'),
          children: [
            {
              path: 'heartChatMessage',
              name: '心聊',
              component: () => import('@/views/plateformOperation/heartChat/heartChatMessage')
            }
          ]
        }
      ]
    },
    {
      path: '/songguoYuncang',
      name: 'songguoYuncang',
      component: Layout,
      children: [
        {
          path: 'settings',
          name: '云仓基础设置',
          component: () => import('@/views/songguoYuncang/settings'),
          children: [
            {
              path: 'labelSettings',
              name: '商品分类设置',
              component: () => import('@/views/songguoYuncang/settings/labelSettings')
            },
            {
              path: 'specificationSettings',
              name: '商品规格设置',
              component: () => import('@/views/songguoYuncang/settings/specificationSettings')
            },
            {
              path: 'storehouseSettings',
              name: '仓库位置设置',
              component: () => import('@/views/songguoYuncang/settings/storehouseSettings')
            }

          ]
        },
        {
          path: 'shopManagement',
          name: '商品设置',
          component: () => import('@/views/songguoYuncang/shopManagement'),
          children: [
            {
              path: 'management',
              name: '商品设置',
              component: () => import('@/views/songguoYuncang/shopManagement/management')
            }

          ]
        },
        {
          path: 'yuncangManagement',
          name: '云仓管理',
          component: () => import('@/views/songguoYuncang/yuncangManagement'),
          children: [
            {
              path: 'stockManagement',
              name: '库存管理',
              component: () => import('@/views/songguoYuncang/yuncangManagement/stockManagement')
            },
            {
              path: 'toStock',
              name: '商品入库',
              component: () => import('@/views/songguoYuncang/yuncangManagement/toStock')
            }

          ]
        },
        {
          path: 'yuncangData',
          name: '云仓数据',
          component: () => import('@/views/songguoYuncang/yuncangData'),
          children: [
            {
              path: 'stockRecords',
              name: '出入库记录',
              component: () => import('@/views/songguoYuncang/yuncangData/stockRecords')
            }
            // {
            //   path: 'garden',
            //   name: '出入库记录(园所)',
            //   component: () => import('@/views/songguoYuncang/yuncangData/garden')
            // },
            // {
            //   path: 'group',
            //   name: '出入库记录(集团)',
            //   component: () => import('@/views/songguoYuncang/yuncangData/group')
            // }

          ]
        }
      ]
    },
    {
      path: '/songguoCollege',
      name: 'songguoCollege',
      component: Layout,
      children: [
        {
          path: 'courseManager',
          name: '课程管理',
          component: () => import('@/views/songguoCollege/courseManager'),
          children: [
            {
              path: 'courseMessage',
              name: '课程信息',
              component: () => import('@/views/songguoCollege/courseManager/courseMessage')
            },
            {
              path: 'applicationRecord',
              name: '课程申请记录',
              component: () => import('@/views/songguoCollege/courseManager/applicationRecord')
            }
          ]
        },
        {
          path: 'faceToFaceManager',
          name: '面授管理',
          component: () => import('@/views/songguoCollege/faceToFaceManager'),
          children: [
            {
              path: 'faceMessage',
              name: '面授信息',
              component: () => import('@/views/songguoCollege/faceToFaceManager/faceMessage')
            },
            {
              path: 'faceSetting',
              name: '面授设置',
              component: () => import('@/views/songguoCollege/faceToFaceManager/faceSetting')
            }
          ]
        },
        {
          path: 'coursewareManagerMain',
          name: '课件管理',
          component: () => import('@/views/songguoCollege/coursewareManagerMain'),
          children: [
            {
              path: 'coursewareManger',
              name: '课件信息',
              component: () => import('@/views/songguoCollege/coursewareManagerMain/coursewareManger')
            }
          ]
        },
        {
          path: 'testManager',
          name: '测练管理',
          component: () => import('@/views/songguoCollege/testManager'),
          children: [
            {
              path: 'topicManager',
              name: '题库管理',
              component: () => import('@/views/songguoCollege/testManager/topicManager')
            }
          ]
        },
        {
          path: 'courseStatistics',
          name: '数据统计',
          component: () => import('@/views/songguoCollege/courseStatistics'),
          children: [
            {
              path: 'studentStudy',
              name: '员工学习数据',
              component: () => import('@/views/songguoCollege/courseStatistics/studentStudy')
            },
            {
              path: 'deparmentCourse',
              name: '课程发布数据',
              component: () => import('@/views/songguoCollege/courseStatistics/deparmentCourse')
            },
            {
              path: 'gardenRank',
              name: '园所排行数据',
              component: () => import('@/views/songguoCollege/courseStatistics/gardenRank')
            },
            {
              path: 'courseStudy',
              name: '课程学习数据',
              component: () => import('@/views/songguoCollege/courseStatistics/courseStudy')
            },
            {
              path: 'deparmentFace',
              name: '面授发布数据',
              component: () => import('@/views/songguoCollege/courseStatistics/deparmentFace')
            },
            {
              path: 'faceSingin',
              name: '面授参与数据',
              component: () => import('@/views/songguoCollege/courseStatistics/faceSingin')
            }
          ]
        },
        {
          path: 'basicSetting',
          name: '学院基础设置',
          component: () => import('@/views/songguoCollege/basicSetting'),
          children: [
            {
              path: 'personManager',
              name: '学院人员管理',
              component: () => import('@/views/songguoCollege/basicSetting/personManager')
            },
            {
              path: 'resourceSetting',
              name: '资源分类设置',
              component: () => import('@/views/songguoCollege/basicSetting/resourceSetting')
            },
            {
              path: 'biaoqianSetting',
              name: '学院标签设置',
              component: () => import('@/views/songguoCollege/basicSetting/biaoqianSetting')
            },
            {
              path: 'rewardSetting',
              name: '学院奖励设置',
              component: () => import('@/views/songguoCollege/basicSetting/rewardSetting')
            }
          ]
        },
        {
          path: 'postTraining',
          name: '跟岗培训',
          component: () => import('@/views/songguoCollege/postTraining'),
          children: [
            {
              path: 'scheduleTemplate',
              name: '日程模板列表',
              component: () => import('@/views/songguoCollege/postTraining/scheduleTemplate')
            },
            {
              path: 'postTrainingList',
              name: '跟岗培训列表',
              component: () => import('@/views/songguoCollege/postTraining/postTrainingList')
            },
            {
              path: 'postapproval',
              name: '跟岗申请审批',
              component: () => import('@/views/songguoCollege/postTraining/postapproval')
            }
          ]
        }
      ]
    },
    {
      path: '/courseCenter',
      name: 'courseCenter',
      component: Layout,
      children: [
        {
          path: '/courseCenter',
          name: '课程中心',
          component: () => import('@/views/courseCenter')
        }
      ]
    },
    {
      path: '/childCare',
      name: 'childCare',
      component: Layout,
      children: [
        {
          path: '/childCare/assessFill',
          name: '观察评估',
          component: () => import('@/views/childCare/assessFill')
        },
        {
          path: 'classActivity',
          name: '课程活动',
          component: () => import('@/views/childCare/classActivity'),
          children: [
            {
              path: 'teachPlanMessage',
              name: '教学计划',
              component: () => import('@/views/childCare/classActivity/teachPlanMessage')
            },
            {
              path: 'teachWeekPlan',
              name: '周计划',
              component: () => import('@/views/childCare/classActivity/teachWeekPlan')
            },
            {
              path: 'classGroupManager',
              name: '课程库管理',
              component: () => import('@/views/childCare/classActivity/classGroupManager')
            }
          ]
        },
        {
          path: 'classActivityWeek',
          name: '每周课程',
          component: () => import('@/views/childCare/classActivityWeek'),
          children: [
            {
              path: 'classActivityWeekSetting',
              name: '课程设置',
              component: () => import('@/views/childCare/classActivityWeek/classActivityWeekSetting')
            }
          ]
        },
        {
          path: 'teachResourceLibrary',
          name: '教学资源库',
          component: () => import('@/views/childCare/teachResourceLibrary'),
          children: [
            {
              path: 'mySubjectResource',
              name: '我的主题资源',
              component: () => import('@/views/childCare/teachResourceLibrary/mySubjectResource')
            },
            {
              path: 'subjectResource',
              name: '主题资源',
              component: () => import('@/views/childCare/teachResourceLibrary/subjectResource')
            }
          ]
        },
        {
          path: '/childCare/growthFile',
          name: '成长记录册',
          component: () => import('@/views/childCare/growthFile'),
          children: [
            {
              path: 'growthFileMake',
              name: '成长册制作',
              component: () => import('@/views/childCare/growthFile/growthFileMake')
            }
          ]
        },
        {
          path: '/childCare/growthAssessment',
          name: '发展评估',
          component: () => import('@/views/childCare/growthAssessment'),
          children: [
            {
              path: 'growthAssessmentMake',
              name: '发展评估',
              component: () => import('@/views/childCare/growthAssessment/growthAssessmentMake')
            }
          ]
        }
      ]
    },
    {
      path: '/resourceLibrary',
      name: 'resourceLibrary',
      component: Layout,
      children: [
        {
          path: '/resourceLibrary/sharingResource',
          name: '共享资源',
          component: () => import('@/views/resourceLibrary/sharingResource')
        }
      ]
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js